import React from 'react';
import Dropdown from '../../formControl/Dropdown';

interface SortDropdownProps {
  sortBy: string;
  onSortChange: (sortOption: string) => void;
}

const sortOptions = [
  { label: 'Newest', value: 'Newest' },
  { label: 'Oldest', value: 'Oldest' },
];

const SortDropdown: React.FC<SortDropdownProps> = ({ sortBy, onSortChange }) => {
  return (
    <Dropdown
      name="sort"
      options={sortOptions}
      value={sortBy}
      onChange={(e) => onSortChange(e.target.value!)}
      className="[&_.main-button]:h-10 [&_.main-button]:rounded-full [&_.main-button]:border [&_.main-button]:border-gray-300 [&_.main-button]:px-6"
      contentWrapperClassName="[&_.content]:!w-full"
      placement="bottom-end"
      offset={8}
    />
  );
};

export default SortDropdown;
